/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/api/request'; // 获取我的备件列表

export function getMySparepartList(data) {
  return request.get('/v2/spare/personalWarehouseList', {
    params: data
  });
}
export function getEnterprises(data) {
  return request.get('/systemsetting/getByCodes', {
    params: data
  });
}
export function getEnterprise(data) {
  return request.get('/systemsetting/getByCode', {
    params: data
  });
} // 保存个人备件

export function getSavePersonal(data) {
  return request.post('/warehouse/spare/savePersonalApartApply', // '/v2/spare/savePersonalApartApply', // deprecated
  data);
}
export function getDistribute(data) {
  return request.post( // '/v2/spare/distribute', // deprecated
  '/warehouse/spare/handover', data);
}